<template>
    <div>
        <v-toolbar app flat dark color="primary">
            <v-btn icon @click="gotoNotificationList()">
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>Berichten</v-toolbar-title>
            <v-btn icon @click="dialog = true;">
                <v-icon>delete</v-icon>
            </v-btn>
        </v-toolbar>

        <v-content class="uf-form" fill-height>
            <template v-if="notification">
                <v-card height="100%">
                    <v-card-title>
                        <div>
                            <div class="headline" v-text="notification.title"></div>
                            <div class="grey--text" v-text="notification.sent_at"></div>
                        </div>
                    </v-card-title>
                    <v-card-text v-html="notification.text"></v-card-text>
                </v-card>
            </template>
        </v-content>

        <v-dialog
                v-model="dialog"
                max-width="290"
        >
            <v-card v-show="notification">
                <v-card-title class="headline">Bericht verwijderen?</v-card-title>
                <v-card-text>
                    Wilt je "{{notification.title}}" verwijderen?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            flat="flat"
                            @click="dialog = false"
                    >
                        Annuleren
                    </v-btn>

                    <v-btn
                            color="red darken-1"
                            flat="flat"
                            @click="dialog = false; deleteNotification();"
                    >
                        Verwijderen
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "NotificationDetailsPage",
        data () {
            return {
                dialog: false,
            }
        },
        computed: {
            ...mapGetters(['notification']),
        },
        methods: {
            deleteNotification() {
                this.$store.dispatch('deleteNotification', this.notification.id).then(() => {
                        this.$store.dispatch('deleteNotification');
                        this.gotoNotificationList();
                    }, (error) => {
                        console.log(error);
                        throw error;
                    });
            },
            gotoNotificationList() {
                this.$router.go(-1);
            }
        },
    }
</script>

<style scoped>

</style>
